import gql from "graphql-tag";
export const GET_TICKET_INCOME_LINE_CHART_CLUB = gql`
  query getBusinessTotalIncomeLineChart(
    $startDate: DateTime!
    $endDate: DateTime!
    $business_profile_id: String
    $club_profile_id: String
  ) {
    getBusinessDashboardTotalTicketsIncomeLineChart(
      input: {
        startDate: $startDate
        endDate: $endDate
        business_profile_id: $business_profile_id
        club_profile_id: $club_profile_id
      }
    ) {
      x
      y
    }
  }
`;